import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {
  @ViewChild('imgmain',{static:true}) img:ElementRef<HTMLImageElement>;
  @Output() bannerClick: EventEmitter<any> = new EventEmitter<any>()
  width:any = 531;
  constructor() { }
  ngOnInit(): void {
    this.width= this.img.nativeElement.getBoundingClientRect().width;
  }
  supportClick() {
    this.bannerClick.emit({ status: true })
  }
}
